{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) MFC Worx
    Address:            Wiefelstederstr. 4a, 26160 Bad Zwischenahn, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             michael.ellermann@mfc-worx.com
    HTTP:               mfc-worx.com

    UnitName:           TPrjHBMDefaultData
    Folder:             ../..
    Created:            Wed 07.12.2023 10:00
    Author:             Michael Ellermann

    ShortDescription:   Hält alle Programm Vorgaben, im Server sowie im Client

    Description:

**                                                                                                **
****************************************************************************************************
MnemoREM}

unit PrjClassHBMDefaultData;



interface

uses
  System.Classes;

type

  TPrjHBMDefaultData = class
  private
    FAktuellePeriode: Integer;
    FAktuelleAbteilung: Integer;
    FAktuellerFall: Integer;
    FAktuellesUnternehmen: Integer;
    FCalculatedCase: Integer;
    FCalculatedDepartment: Integer;
    FCalculatedEnterprise: Integer;
    FCalculatedPeriod: Integer;
    FCodierCaseManagement: Integer;
    FErtragAuschuettung: Integer;
    FFinanzSachanlagen: Integer;
    FPeriodeGerechnet: Integer;
    FKreditTilgung: Integer;
    FLaundryOutsourced: Integer;
    FLetztePeriode: Integer;
    FLetztesUnternehmen: Integer;
    FLockMessage: string;
    FMaxAnzUnternehmen: Integer;
    FMinAnzUnternehmen: Integer;
    FSeminarName: string;
    FSystemIsLocked: Boolean;
    FTLNIsLocked: boolean;
    FTLNSaveCount: integer;
    FVorkalkulation: Integer;
    FWertpapiere: Integer;
  published
    property AktuellerFall: Integer read FAktuellerFall write FAktuellerFall;
    property AktuellePeriode: Integer read FAktuellePeriode write FAktuellePeriode;
    property AktuellesUnternehmen: Integer read FAktuellesUnternehmen write FAktuellesUnternehmen;
    property AktuelleAbteilung: Integer read FAktuelleAbteilung write FAktuelleAbteilung;
    property CalculatedCase: Integer read FCalculatedCase write FCalculatedCase;
    property CalculatedPeriod: Integer read FCalculatedPeriod write FCalculatedPeriod;
    property CalculatedEnterprise: Integer read FCalculatedEnterprise write FCalculatedEnterprise;
    property CalculatedDepartment: Integer read FCalculatedDepartment write FCalculatedDepartment;
    property CodierCaseManagement: Integer read FCodierCaseManagement write FCodierCaseManagement;
    property ErtragAuschuettung: Integer read FErtragAuschuettung write FErtragAuschuettung;
    property FinanzSachanlagen: Integer read FFinanzSachanlagen write FFinanzSachanlagen;
    property PeriodeGerechnet: Integer read FPeriodeGerechnet write FPeriodeGerechnet default -1;
    property KreditTilgung: Integer read FKreditTilgung write FKreditTilgung;
    property LaundryOutsourced: Integer read FLaundryOutsourced write FLaundryOutsourced;
    property LetztePeriode: Integer read FLetztePeriode write FLetztePeriode;
    property LetztesUnternehmen: Integer read FLetztesUnternehmen write FLetztesUnternehmen;
    property LockMessage: string read FLockMessage write FLockMessage;
    property MaxAnzUnternehmen: Integer read FMaxAnzUnternehmen write FMaxAnzUnternehmen;
    property MinAnzUnternehmen: Integer read FMinAnzUnternehmen write FMinAnzUnternehmen;
    property SeminarName: string read FSeminarName write FSeminarName;
    property SystemIsLocked: Boolean read FSystemIsLocked write FSystemIsLocked default false;
    property Vorkalkulation: Integer read FVorkalkulation write FVorkalkulation;
    property Wertpapiere: Integer read FWertpapiere write FWertpapiere;
    property TLNIsLocked: boolean read FTLNIsLocked write FTLNIsLocked default false;
    property TLNSaveCount: integer read FTLNSaveCount write FTLNSaveCount;
  end;

implementation


end.
